import React, { Fragment, useEffect, useRef, useState } from "react";
import { compose } from "redux";
import enhancer from "./validator";
import Button from "../button/Button";
import { ImageResolution } from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import SubAdminServices from "../../api/SubAdminServices";
import Toaster from "../common/Toaster";
import { PLACEHOLDER } from "helper/constant";
import { Input } from "reactstrap";
import PracticeMangementServices from "api/PracticeManagementServices";

const SubAdminForm = props => {
  const {
    handleChange,
    handleBlur,
    errors,
    setFieldTouched,
    setFieldValue,
    touched,
    submitCount,
    onSubmit,
    values,
    action,
    types
  } = props;

  const toaster = useRef(null);
  const [imageObj, setImageObj] = useState(null);
  const [uploadImage, setUploadImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [practiceList, setPracticeList] = useState([]);

  useEffect(() => {
    if (!practiceList?.length || (!practiceList?.length && values?.role == 6)) {
      PracticeMangementServices.list({ get_all: true }).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data?.status) {
          setPracticeList([...data?.data]);
        }
      });
    }
  }, [values?.role]);

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };

  const handleImage = (e, setValue) => {
    if (e.target.files[0]) {
      let fileObj = e.target.files[0];

      if (fileObj.size > 10 * 1024 * 1024) {
        if (toaster.current)
          toaster.current.error("Please upload a file smaller than 10 MB");
        return false;
      }

      if (!fileObj.name.match(/\.(jpg|jpeg|png|gif|heif)$/)) {
        if (toaster.current)
          toaster.current.error(
            "Only .jpg, .jpeg, .gif, .png, .heif are allowed"
          );
        return false;
      }

      if (fileObj) {
        const img = new Image();

        img.src = window.URL.createObjectURL(fileObj);

        img.onload = function() {
          const width = img.naturalWidth,
            height = img.naturalHeight;

          window.URL.revokeObjectURL(img.src);
          setValue("width", width);
          setValue("height", height);
          setFieldTouched("image", true, true);
          if (
            width >= ImageResolution.WIDTH &&
            height >= ImageResolution.HEIGHT
          ) {
            setImageObj(fileObj);
            setValue("image", URL.createObjectURL(fileObj));
            setUploadImage(URL.createObjectURL(fileObj));
          }
        };
      } else {
        //No file was input or browser doesn't support client side reading
        // form.submit();
      }
    } else {
      setUploadImage();
    }
  };

  const handleSubmit = () => {
    let { values, isValid, handleSubmit } = props;

    if (isValid) {
      setIsLoading(true);
      if (action === "add") {
        const params = {
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          admin_role_id: values.role,
          practice_id: values?.practice ? values?.practice : undefined
        };

        const formdata = new FormData();
        const encryptData = EncryptDecrypt.encrypt(params);
        formdata.append("data", encryptData?.data);
        if (imageObj) formdata.append("data1", imageObj);

        SubAdminServices.add(formdata)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);
              onSubmit(values, action);
            } else {
              if (toaster.current) toaster.current.error(data.message);
              setIsLoading(false);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
            setIsLoading(false);
          });
      } else if (action === "edit") {
        const params = {
          id: values.id,
          first_name: values.first_name,
          last_name: values.last_name,
          email: values.email,
          admin_role_id: values.role,
          practice_id: values?.practice ? values?.practice : undefined
        };

        const formdata = new FormData();
        const encryptData = EncryptDecrypt.encrypt(params);
        formdata.append("data", encryptData?.data);
        if (imageObj) formdata.append("data1", imageObj);

        SubAdminServices.edit(formdata)
          .then(res => {
            let data = EncryptDecrypt.decrypt(res.data);
            if (data.status) {
              if (toaster.current) toaster.current.success(data.message);
              onSubmit(values, action);
            } else {
              if (toaster.current) toaster.current.error(data.message);
              setIsLoading(false);
            }
          })
          .catch(err => {
            if (toaster.current) toaster.current.error(err.response);
            setIsLoading(false);
          });
      }
    }

    handleSubmit();
  };

  return (
    <div>
      <form>
        <div className="form-group">
          <label className="fs-16 medium-text">
            First Name <span className="asterisk">*</span>
          </label>
          <input
            type="text"
            className="form-control react-form-input"
            id="first_name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.first_name}
            placeholder="Add First Name"
          />
          <Error field="first_name" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Last Name <span className="asterisk">*</span>
          </label>
          <input
            type="text"
            className="form-control react-form-input"
            id="last_name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.last_name}
            placeholder="Add Last Name"
          />
          <Error field="last_name" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Email <span className="asterisk">*</span>
          </label>
          <input
            type="text"
            className="form-control react-form-input"
            id="email"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.email}
            placeholder="Add Email"
            disabled={action === "edit"}
          />
          <Error field="email" />
        </div>
        <div className="form-group">
          <label className="fs-16 medium-text">
            Admin Type<span className="asterisk">*</span>
          </label>
          <Input
            type="select"
            name=""
            id="role"
            onChange={handleChange}
            value={values.role}
            onBlur={handleBlur}
          >
            <option value="">Select Admin Type</option>
            {types.map((type, i) => {
              return (
                <Fragment>
                  <option key={`option${i}`} value={type.id}>
                    {type.role}
                  </option>
                </Fragment>
              );
            })}
          </Input>
          <Error field="role" />
        </div>
        {values?.role == 6 && (
          <div className="form-group">
            <label className="fs-16 medium-text">
              Practice<span className="asterisk">*</span>
            </label>
            <Input
              type="select"
              name=""
              id="practice"
              onChange={handleChange}
              value={values.practice}
              onBlur={handleBlur}
            >
              <option value="">Select Practice</option>
              {practiceList.map((type, i) => {
                return (
                  <Fragment>
                    <option key={`option${i}`} value={type.id}>
                      {type.practice_name}
                    </option>
                  </Fragment>
                );
              })}
            </Input>
            <Error field="practice" />
          </div>
        )}
        <div>
          <div className="form-group">
            <label className="fs-16 medium-text">Image</label>
            <br />
            <div className="file-upload">
              <label className="c-btn c-primary form-button fs-16 demi-bold-text mt-15">
                Upload image
                <input
                  id="image"
                  className="file-upload__input"
                  name="file-upload"
                  type="file"
                  accept="image/jpg,image/png,image/jpeg"
                  onChange={e => handleImage(e, setFieldValue)}
                  onBlur={handleBlur}
                  onClick={event => {
                    event.target.value = "";
                  }}
                />
              </label>
            </div>
            <br />
            {
              <img
                src={uploadImage ? uploadImage : values.image || PLACEHOLDER}
                alt=""
                className="mtb-15"
                style={{
                  width: "200px",
                  borderRadius: "4%",
                  height: "150px",
                  background: "#404040"
                }}
              />
            }
            <br />
            <Error field="image" />
          </div>
        </div>
        <div>
          <Button
            type="button"
            className="c-btn c-info form-button fs-16 demi-bold-text max-w-125"
            loading={isLoading}
            disabled={isLoading}
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>
        </div>
      </form>
      <Toaster ref={toaster} />
    </div>
  );
};

export default compose(enhancer)(SubAdminForm);
